export const birthdayDayjsFormats = ['MM-DD-YYYY', 'M-DD-YYYY', 'M-D-YYYY', 'YYYY-MM-DD']
